import { useState } from "react";

export default function usePostOrder() {
  const [respStatus, setRespStatus] = useState(0);

  const postOrder = async (data) => {
    try {
      setRespStatus(1);

      const response = await fetch(
        "https://hogast.hr/wp/wp-json/custom/v1/order",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          mode: "cors",
          body: JSON.stringify(data),
        }
      );

      if (response.ok) {
        setRespStatus(2);
      } else {
        setRespStatus(-1);
        console.log(response);
      }
    } catch (err) {
      setRespStatus(-1);

      console.log("Loading error: ", err.message);
    }
  };

  return [respStatus, setRespStatus, postOrder];
}
